export const FETCH_ACCOUNT_STATEMENTS_REQUEST = 'FETCH_ACCOUNT_STATEMENTS_REQUEST';
export const FETCH_ACCOUNT_STATEMENTS_SUCCESS = 'FETCH_ACCOUNT_STATEMENTS_SUCCESS';
export const FETCH_ACCOUNT_STATEMENTS_FAILED = 'FETCH_ACCOUNT_STATEMENTS_FAILED';

export const FETCH_ACCOUNT_STATEMENT_BY_ID_REQUEST = 'FETCH_ACCOUNT_STATEMENT_BY_ID_REQUEST';
export const FETCH_ACCOUNT_STATEMENT_BY_ID_SUCCESS = 'FETCH_ACCOUNT_STATEMENT_BY_ID_SUCCESS';
export const FETCH_ACCOUNT_STATEMENT_BY_ID_FAILED = 'FETCH_ACCOUNT_STATEMENT_BY_ID_FAILED';

export const PROCESS_BALANCE_ACCOUNT_STATEMENT_BY_ID_REQUEST =
  'PROCESS_BALANCE_ACCOUNT_STATEMENT_BY_ID_REQUEST';
export const PROCESS_BALANCE_ACCOUNT_STATEMENT_BY_ID_SUCCESS =
  'PROCESS_BALANCE_ACCOUNT_STATEMENT_BY_ID_SUCCESS';
export const PROCESS_BALANCE_ACCOUNT_STATEMENT_BY_ID_FAILED =
  'PROCESS_BALANCE_ACCOUNT_STATEMENT_BY_ID_FAILED';

export const PROCESS_BALANCE_ACCOUNT_STATEMENT_BY_BULK_REQUEST =
  'PROCESS_BALANCE_ACCOUNT_STATEMENT_BY_BULK_REQUEST';
export const PROCESS_BALANCE_ACCOUNT_STATEMENT_BY_BULK_SUCCESS =
  'PROCESS_BALANCE_ACCOUNT_STATEMENT_BY_BULK_SUCCESS';
export const PROCESS_BALANCE_ACCOUNT_STATEMENT_BY_BULK_FAILED =
  'PROCESS_BALANCE_ACCOUNT_STATEMENT_BY_BULK_FAILED';
